<template>
  <div>
    <!-- In your resell page -->
    <AddNewProductComp :title="'sentence.tellUsWhatYouAreReselling'" mode="resell" />
  </div>
</template>

<script>
import AddNewProductComp from '@/components/add-product/AddNewProductComp.vue';

export default {
  name: 'ResellPage',
  components: {
    AddNewProductComp
  }
}
</script>